// extracted by mini-css-extract-plugin
module.exports = {"configurationInvoice":"styles_configurationInvoice__33bsB"};